var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden-element"},[_c('div',{staticClass:"input-section"},[_c('input',{attrs:{"id":_vm.elementId,"type":"hidden","data-eid":_vm.elementId,"data-rid":_vm.repeaterId},domProps:{"value":_vm.fieldValue}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }